import { render } from "./corporateView.vue?vue&type=template&id=d2a15638"
import script from "./corporateView.vue?vue&type=script&lang=js"
export * from "./corporateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__